/** @format */

import { plainApi } from "./client";

interface AcceptInvitationResponse {
  orgId: string;
  email: string;
  role: string;
  temporaryPasswordIssued: boolean;
}

const inflightAcceptRequests = new Map<string, Promise<AcceptInvitationResponse>>();

export async function acceptOrganizationInvitation(
  token: string,
): Promise<AcceptInvitationResponse> {
  const normalizedToken = token.trim();
  const existingRequest = inflightAcceptRequests.get(normalizedToken);
  if (existingRequest) return existingRequest;

  const request = plainApi
    .post<AcceptInvitationResponse>("/organization_invitations/accept", {
      token: normalizedToken,
    })
    .then((response) => response.data)
    .finally(() => {
      inflightAcceptRequests.delete(normalizedToken);
    });

  inflightAcceptRequests.set(normalizedToken, request);
  return request;
}

